import React, { useState, useEffect } from "react";
import Select from "react-select";
import OneWayPickupServices from "services/OnewayPickupServices";

const SelectOneWayPackage = ({
  register,
  selectedPackage,
  handlePackageChange,
  handlePackageLabelChange,
  name,
  label,
  readonly,
  handleType,
  handleSeat,
  id,
}) => {
  const [packages, setPackages] = useState([]);

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      border: "1px",
      boxShadow: "none",
      backgroundColor: state.isDisabled ? "#E2E8F0" : "#FFFFFF",
      cursor: state.isDisabled ? "not-allowed" : "default",
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected
        ? "#ffffff"
        : state.isFocused
          ? "rgba(0, 0, 0, 0.15)"
          : "white",
      color: state.isSelected ? "black" : state.onClick ? "green" : "black",
      "&:hover": {
        background: "#1769aa",
        color: "white",
      },
    }),
    menu: (provided) => ({
      ...provided,
      margin: "10px 0 -10px 0",
      zIndex: "55555",
      overflow: "hidden",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "150px",
      overflowY: "scroll",
      scrollbarWidth: "thin",
      scrollbarColor: "#888 #f1f1f1",
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "3px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the separator line
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "inherit", // or remove this line entirely if you want to use inherited/default styling
    }),
  };

  useEffect(() => {
    let isMounted = true;

    async function fetchPackages() {
      try {
        // const response =
        //   await OneWayPickupServices.getAllOnewayPickupBasicRate();
        const response = await OneWayPickupServices.listOnewayOptions();

        const transformedData = response.data.map((item) => ({
          value: String(item.id),
          label: `${item.from_city_name} - ${item.to_city_name}`,

          fromCityId: Array.isArray(item.from_city)
            ? item.from_city
            : [item.from_city],
          toCityId: Array.isArray(item.to_city) ? item.to_city : [item.to_city],

          fromCityName: Array.isArray(item.from_city_name)
            ? item.from_city_name
            : [item.from_city_name],

          toCityName: Array.isArray(item.to_city_name)
            ? item.to_city_name
            : [item.to_city_name],

          vehicle_type_ids: Array.isArray(item.vehicle_type_id)
            ? item.vehicle_type_id.flat()
            : [item.vehicle_type_id],

          vehicle_type_names: Array.isArray(item.vehicle_type_names)
            ? item.vehicle_type_names[0] || {}
            : item.vehicle_type_names || {},

          min_rate: Array.isArray(item.min_rate)
            ? item.min_rate[0] || {}
            : item.min_rate || {},
        }));

        if (isMounted) {
          setPackages(transformedData);

          if (selectedPackage?.value) {
            const matched = transformedData.find(
              (pkg) => pkg.value === String(selectedPackage.value),
            );

            if (matched && handlePackageChange) {
              handlePackageChange(matched);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching one way packages:", error);
      }
    }

    fetchPackages();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleSelect = (selected) => {
    if (!selected) return;

    if (handlePackageChange) {
      handlePackageChange(selected);
    } else {
      handleType("");
      handleSeat(null);
    }
  };

  return (
    <Select
      className="dark:text-white-300 leading-5 rounded-md focus:border-white-200 border-gray-200 dark:border-gray-600 focus:ring focus:ring-green-300 dark:focus:border-gray-500 dark:focus:ring-gray-300 dark:bg-gray-700 border h-10 text-sm focus:outline-none block w-full bg-white-100 border-transparent focus:bg-white"
      {...register(`${name}`, {
        required: !selectedPackage ? `${label} is required!` : false,
      })}
      name={name}
      isDisabled={readonly}
      styles={customSelectStyles}
      options={packages}
      onChange={handleSelect}
      value={selectedPackage || null}
    />
  );
};

export default SelectOneWayPackage;
